// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"dropdown_dropdown__oT3id","dropdown-wrapper":"dropdown_dropdown-wrapper__klo3y","single-value":"dropdown_single-value__JvCz4"};